import { createRouter, createWebHistory } from 'vue-router';
import Layout from '../components/layouts/TenantLayout.vue';
import TenantServicesIndex from '../components/TenantServicesIndex.vue';
import ServiceDetails from '../components/ServiceDetails.vue';

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../components/Login.vue')
  },
  {
    path: '/logout',
    name: 'Logout',
    component: () => import('../components/Logout.vue')
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../components/Register.vue')
  },
  {
    path: '/error',
    name: 'ErrorPage',
    component: () => import('../components/ErrorPage.vue')
  },
  {
    path: '/',
    component: Layout, // Use Layout as a wrapper
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('../components/Dashboard.vue')
      },
      {
        path: 'tenantservices',
        name: 'tenantservices.index',
        component: TenantServicesIndex
      },
      {
        path: 'service/:id',
        name: 'service.details',
        component: ServiceDetails,
        props: true
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

router.beforeEach((to, from, next) => {
  const user = JSON.parse(localStorage.getItem('user'));

  if (!user && to.name !== 'Login') {
    // If user information is not present and the route is not the login page,
    // redirect to the login page
    return next({ name: 'Login' });
  }

  if (to.path === '/login' && user) {
    const role = user.role;
    if (role === 'admin') {
      return next({ name: 'AdminDashboard' });
    } else if (role === 'user') {
      return next({ name: 'UserDashboard' });
    } else if (role === 'agent') {
      return next({ name: 'AgentDashboard' });
    } else if (role === 'guest') {
      return next({ name: 'GuestDashboard' });
    }
  }

  if (to.meta.requiresAuth && !user) {
    return next({ name: 'Login' });
  }

  if (to.meta.requiresAuth && user) {
    const role = user.role;
    if (to.meta.role !== role) {
      return next({ name: 'Home' }); // Redirect to Home if role doesn't match
    }
  }

  next();
});

export default router;
